import { render, staticRenderFns } from "./inventoryWebhook.vue?vue&type=template&id=bd1bdee0&scoped=true"
import script from "./inventoryWebhook.vue?vue&type=script&lang=js"
export * from "./inventoryWebhook.vue?vue&type=script&lang=js"
import style0 from "./inventoryWebhook.vue?vue&type=style&index=0&id=bd1bdee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1bdee0",
  null
  
)

export default component.exports